import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { withPageContext } from '../../utils/PageContext/PageContext';
import { DropdownItem } from '../../components/DropdownItem/DropdownItem';

const InspirationalSearchSelector = ({ trackEvent, onClickItem }) => {
    const { t } = useTranslation();
    const getInspirationalText = () => {
        const title = t('inspirational.airportselector.title');
        const subtitle = t('inspirational.airportselector.subtitle');
        return `${title} ${subtitle}`;
    };

    const handleClickItem = () => {
        const inspirationalText = getInspirationalText();
        const value = {
            city: inspirationalText,
            name: inspirationalText,
            iata: 'INSP',
            geoNodeId: 0,
            geoNodeType: 'CITY',
            type: 'CITY',
            countryCode: '',
        };
        onClickItem(value);
        trackEvent({ action: 'searcher_flights', label: 'picker:arrival_sel:anywhere' });
    };
    const inspirationalText = getInspirationalText();
    return (
        <DropdownItem onClick={handleClickItem} iconClass="odf-icon-compass odf-text-action">
            {inspirationalText}
        </DropdownItem>
    );
};

InspirationalSearchSelector.propTypes = {
    onClickItem: PropTypes.func.isRequired,
    trackEvent: PropTypes.func.isRequired,
};

const connected = withPageContext(InspirationalSearchSelector);
export { connected as InspirationalSearchSelector };
